import React from 'react'
import './PlanComponent.css'
import { useSelector, useDispatch } from 'react-redux'
import { setPlanDuration } from '../../redux/reducer'
import { PlanInfo } from '../Data/Data'
import {selectedPlan} from '../../redux/reducer'

const PlanComponent = () => {
    const [isActive,setActive] = React.useState(null)
    const planDuration = useSelector((state) => state.planDuration)
    const plan = useSelector((state) => state.Plan)

    
    const dispatch = useDispatch()

    const handleCard = (id,plan) => {
        setActive(id);
        dispatch(selectedPlan(plan))
        
        
    }
    
    return (
        <div className="PlanComponent">
            {PlanInfo.map((plan) => {
                return (
                    <div className={`Card1 ${isActive === plan.id ? 'cardActive' : ''}`}  key={plan.planInfo} onClick={()=>handleCard(plan.id,plan)} id={plan.id}>
                        <img src={plan.Image} alt={plan.planInfo} />
                        <div className='Textplan'>
                            <p className='planName'>{plan.planInfo}</p>
                            <p className='planType'>{ planDuration === "Yearly" ? `$${plan.yearlyPrice}/yr`:`$${plan.price}/mo` }</p>
                            {planDuration === "Yearly" && (
                                <p className='duration'>2 months free</p>
                            )}
                        </div>
                    </div>
                )
            })}

             <div className="Card4">
                <p className='switchtoMonth' >Monthly</p>
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" onChange={()=>dispatch(setPlanDuration())} role="switch" id="switchCheckChecked" />
                   
                </div>
                <p className='switchtoYear' >Yearly</p>
            </div>
        </div>
    )
}

export default PlanComponent